import { combineReducers } from "redux";
import applicationReducer from "reducers/applicationReducer";
import authReducer from "reducers/authReducer";
import modalReducer from "reducers/modalReducer";
import announcementsReducer from "reducers/announcementsReducer";
import introVideosReducer from "reducers/introVideosReducer";
import fileReducer from "reducers/fileReducer";
import faqReducer from "reducers/faqReducer";
import statsReducer from "reducers/statsReducer";
import guideReducer from "reducers/guideReducer";
import profileReducer from "reducers/profileReducer";
import notificationsReducer from "reducers/notificationsReducer";
import trainingsReducer from "reducers/trainingsReducer";
import invoicesReducer from "reducers/invoicesReducer";
import calendarReducer from "reducers/calendarReducer";
import organisationReducer from "reducers/organisationReducer";
import dealerReducer from "reducers/dealerReducer";
import surveyReducer from "reducers/surveyReducer";
import evolutionplanReducer from "reducers/evolutionplanReducer";
import competencyReducer from "reducers/competencyReducer";
import allRegisteredTrainingsReducer from "reducers/allRegisteredTrainingsReducer";
import employeeRolesReducer from "reducers/employeeRolesReducer";
import employeeManagementReducer from "reducers/employeeManagementReducer";
import getInformationalVideosReducer from "reducers/getInformationalVideosReducer";

const appReducer = combineReducers({
  application: applicationReducer,
  auth: authReducer,
  modal: modalReducer,
  announcements: announcementsReducer,
  introVideos: introVideosReducer,
  files: fileReducer,
  faq: faqReducer,
  stats: statsReducer,
  guide: guideReducer,
  profile: profileReducer,
  notifications: notificationsReducer,
  trainings: trainingsReducer,
  invoices: invoicesReducer,
  calendar: calendarReducer,
  organisationActivities: organisationReducer,
  dealerInfo: dealerReducer,
  myTeam: organisationReducer,
  survey: surveyReducer,
  evolutionPlan: evolutionplanReducer,
  competency: competencyReducer,
  allRegisteredTrainings: allRegisteredTrainingsReducer,
  employeeRoles: employeeRolesReducer,
  employeeManagement: employeeManagementReducer,
  informationalVideos: getInformationalVideosReducer
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT_SUCCESS") {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
